/**
 * 系统状态行（公共组件）。
 *
 * 原 ControlPanel / Dashboard 各抄了一份，抽公共复用。
 */
import { cn } from "@/lib/utils";

export default function StatusRow({
  label,
  value,
  ok,
  okText = "已启用",
  badText = "未启用",
  reverse = false,
}: {
  label: string;
  value?: string;
  ok?: boolean;
  okText?: string;
  badText?: string;
  reverse?: boolean;
}) {
  const isOk = reverse ? ok === false : ok === true;
  return (
    <div className="flex items-center justify-between">
      <span className="text-ink-400">{label}</span>
      {value !== undefined ? (
        <span className="text-ink-200 num">{value}</span>
      ) : (
        <span className={cn("flex items-center gap-1", isOk ? "text-bull" : "text-ink-500")}>
          <span className={cn("w-1.5 h-1.5 rounded-full", isOk ? "bg-bull" : "bg-ink-600")} />
          {isOk ? okText : badText}
        </span>
      )}
    </div>
  );
}
